import styled from 'styled-components/native'


export const Avatar = styled.Image`
width: ${({ width }) => width};
height: ${({ height }) => height || '100%'};
`;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  height: ${({ height }) => (height ? height : '3')}rem;
`;

export const ViewLogo = styled.View`
  align-items: center;
  height: 3rem;
  padding: 0.2rem;
`;

export const Content = styled.View`
  align-items: center;
  justify-content: center;
  flex-direction: row; 
  padding: 0.5rem 0rem;
`;

/* `compact` = celular: as margens de 0.5rem somavam ~1rem entre ícones e
   espremiam a linha quando o header tem 3 ou mais ações. O min-height mantém
   a área de toque confortável mesmo com o ícone menor. */
export const IconButton = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  flex-direction: row;
  min-height: 40px;
  margin-horizontal: ${({ compact }) => (compact ? '0.25rem' : '0.5rem')};
`;
